/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Companynamelabel3Inputs */

const ja_company_companydetails_companynamelabel3 = /** @type {(inputs: Company_Companydetails_Companynamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会社名`)
};

const en_company_companydetails_companynamelabel3 = /** @type {(inputs: Company_Companydetails_Companynamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Name`)
};

/**
* | output |
* | --- |
* | "Company Name" |
*
* @param {Company_Companydetails_Companynamelabel3Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_companynamelabel3 = /** @type {((inputs?: Company_Companydetails_Companynamelabel3Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Companynamelabel3Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_companynamelabel3(inputs)
	return en_company_companydetails_companynamelabel3(inputs)
});
export { company_companydetails_companynamelabel3 as "company_companyDetails_companyNameLabel" }